const initPopover = () => {
  const popover = $('#popover')
  const trigger = $('#popover-trigger')
  const closeBtn = $('#popover-close-btn')

  trigger.on('click', () => {
    popover.toggleClass('site-header__popover--show')
  })

  closeBtn.on('click', () => {
    popover.removeClass('site-header__popover--show')
  })
}

const initDropdowns = () => {
  $('#enterprise').dropdown()
  $('#developers').dropdown()
  $('#consumers').dropdown()
  $('#about').dropdown()
}

const getSession = async () => {
  const res = await fetch('https://bloom.co/api/sessions', {
    credentials: 'same-origin',
    headers: new Headers({
      'CSRF-TOKEN': '',
      'Content-Type': 'application/json',
    }),
    method: 'get',
  })

  if (res.status === 200) {
    $('[data-login-link]').each((_, elem) => {
      elem.href = 'https://bloom.co/app'
      const btn = $(elem).find('.btn')[0]
      if (btn) $(btn).text('Go To App')
    })
  }
}

const main = () => {
  initPopover()
  initDropdowns()
  void getSession()
}

main()
